import type { PlatformName } from "types"

export const AUTO_TIMEFRAME_PLATFORMS: PlatformName[] = ["POAP"]
